export default {
    url: 'x-core-3',
    include: ['us', 'ca', 'jp', 'eu', 'uk', 'de', 'fr', 'it', 'es'],
};
